<template>
  <div>
    <slot />
    <Transition :name="animationName">
        <media-background :key="imgUri" :img-uri="imgUri" :lazy="loading === 'lazy'" />
    </Transition>
  </div>
</template>
<script setup lang="ts">
const { imgUri, fadeSlow = false, loading = 'lazy' } = defineProps<{
    imgUri: string,
    fadeSlow?: boolean,
    loading?: string,
}>();

const animationName = fadeSlow ? 'fade-slow' : 'fade';
</script>

<style lang="scss">

</style>